import * as React from 'react';
import { useAtomValue } from 'jotai';
import { useTranslation } from 'next-i18next';

import { Heading } from '@restworld/ui-ds-base';

import { workerTrainingsAtom } from '../../../../employer-job-listing.atoms';
import { TabCardWrapper } from '../candidate-profile-section';
import { StyledSeparator } from './worker-experience';
import { TrainingSectionItem } from './training-section-item';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface ITrainingSectionProps {}

const TrainingSection: React.FunctionComponent<ITrainingSectionProps> = (props) => {
  const workerTrainings = useAtomValue(workerTrainingsAtom);
  const itemsCount = workerTrainings?.length || 0;
  const { t } = useTranslation('onboarding-page');

  return (
    <TabCardWrapper title={t('training')}>
      <div className="flex flex-col items-start pt-4">
        {workerTrainings?.map((workerTraining, index) => (
          <div className="w-full" key={index} id={`education-${index}`}>
            <TrainingSectionItem key={index} {...{ workerTrainingIndex: index, workerTraining }} />
            {index < itemsCount - 1 && <StyledSeparator />}
          </div>
        ))}
        {!workerTrainings?.length && (
          <Heading size={5} weight="normal" color="muted">
            {t('missing_info')}
          </Heading>
        )}
      </div>
    </TabCardWrapper>
  );
};

export default TrainingSection;
